export default __webpack_public_path__ + "static/b_helles_03-5d3e3def09b90e32f24ceec1c28ed072.png";